import { PropsWithChildren } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { useDeleteLetter } from 'assets/js/pages/engage/letters/useDeleteLetter';

interface DeleteLetterAlertDialogProps extends PropsWithChildren {
    messageId: number;
    onSuccess?: () => void;
}

const DeleteLetterAlertDialog = (props: DeleteLetterAlertDialogProps) => {
    const { messageId, children, onSuccess } = props;
    const { mutate: deleteMessage } = useDeleteLetter({
        onSuccess: () => onSuccess?.(),
    });

    return (
        <AlertDialog.Root type={'error'}>
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Delete letter</AlertDialog.Title>
                        <AlertDialog.Description>
                            You will not be able to undo this action.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>Close</AlertDialog.Cancel>
                        <AlertDialog.Action onClick={() => deleteMessage(messageId)}>
                            Delete
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const DeleteLetterAlertDialogTrigger = AlertDialog.Trigger;

const Root = DeleteLetterAlertDialog;
const Trigger = DeleteLetterAlertDialogTrigger;

export {
    Root,
    Trigger,
    //
    DeleteLetterAlertDialog,
    DeleteLetterAlertDialogTrigger,
};
export type { DeleteLetterAlertDialogProps };
